export const fr = {
    translation: {
        b: {
            cancel: 'Annuler',
            confirm: 'Confirmer',
            send: 'Envoyer',
            done: 'Terminé',
            close: 'Fermer',
            clear: 'Effacer',
            copy_link: 'Copier le lien',
            export: 'Exporter',
            delete: 'Supprimer',
            delete_confirm: 'Confirmer la suppression',
            duplicate: 'Dupliquer',
            share: 'Partager',
            sign_in: 'Se connecter',
            sign_up: 'S’inscrire',
            email_address: 'Adresse e-mail',
            yes: 'Oui',
            no: 'Non'
        },
        m_languages: {
            title: 'Langues',
            subtitle: 'Choisissez une langue'
        },
        m_feedback: {
            feature: {
                name: 'Demande de fonctionnalité',
                desc: 'Il vous manque une fonctionnalité ? Dites-le nous — vos idées comptent'
            },
            feedback: {
                name: 'Commentaires',
                desc: 'Vos retours comptent énormément pour nous — laissez-nous un petit message'
            }
        },
        m_feedback_t: {
            feature: {
                name: 'Merci pour votre suggestion !',
                desc: 'Merci d’avoir pris le temps de partager votre avis — cela nous aide à améliorer le produit.'
            },
            feedback: {
                name: 'Merci pour votre retour !',
                desc: 'Merci d’avoir pris le temps de partager votre avis — cela nous aide à améliorer le produit.'
            }
        },
        m_diagram_details: {
            name_place: 'Saisir le nom du projet',
            desc_place: 'Saisir la description du projet'
        },
        m_quick_share: {
            title: 'Partage rapide',
            subtitle: '(Partage par lien)'
        },
        m_export_img: {
            title: 'Exporter l’image'
        },
        m_export_code: {
            title: 'Exporter le code {{db_engine}}',
            download_file: 'Télécharger le fichier',
            copy_code: 'Copier le code'
        },
        m_sign_in_remind: {
            title: 'Merci d’essayer DB Design',
            subtitle: 'Connectez-vous ou inscrivez-vous pour augmenter le nombre maximal de tables, enregistrer des diagrammes et débloquer plus de fonctionnalités.'
        },
        m_sign_in_restrict: {
            title: 'Connectez-vous pour en faire plus',
            subtitle: 'Connectez-vous ou inscrivez-vous pour augmenter les limites de tables, enregistrer des diagrammes et débloquer plus de fonctionnalités.'
        },
        m_new_diagram: {
            title: 'Nouveau diagramme',
            subtitle: 'Choisissez un moteur de base de données',
            open_diagram: 'Ouvrir le diagramme'
        },
        m_keyboard_shortcuts: {
            title: 'Raccourcis clavier',
            ctrl_left: {
                title1: 'Contrôles',
                title2: '(Gauche)',
                items: {
                    mouse_sel: 'Mode sélection / Mode main',
                    table: 'Table',
                    line: 'Ligne',
                    area: 'Zone',
                    note: 'Remarque',
                    comment: 'Commentaire',
                    pen: 'Stylo',
                    undo: 'Annuler',
                    redo: 'Rétablir'
                }
            },
            ctrl_top_left: {
                title1: 'Contrôles',
                title2: '(En haut à gauche)',
                items: {
                    export_img: 'Exporter une image',
                    search: 'Rechercher',
                    editor_panel: 'Panneau de l’éditeur'
                }
            },
            ctrl_bottom_right: {
                title1: 'Contrôles',
                title2: '(En bas à droite)',
                items: {
                    minimap: 'Mini-carte',
                    zoom_in: 'Zoom avant',
                    zoom_out: 'Zoom arrière',
                    zoom_100: 'Zoom à 100 %'
                }
            },
            ctx_tab: {
                title1: 'Menu contextuel',
                title2: '(Table)',
                items: {
                    dupl_tab: 'Dupliquer la table',
                    del_tab: 'Supprimer la table'
                }
            },
            ctx_del_tab: {
                title1: 'Menu contextuel',
                title2: '(Supprimer la table)',
                items: {
                    yes: 'Oui',
                    no: 'Non'
                }
            },
            ctx_tab_col: {
                title1: 'Menu contextuel',
                title2: '(Colonne)', // (Colonne de table)
                items: {
                    add_col_below: 'Ajouter une colonne en dessous',
                    focus_col_above: 'Focus sur la colonne au-dessus',
                    focus_col_below: 'Focus sur la colonne au-dessous',
                    move_col_up: 'Monter la colonne',
                    move_col_down: 'Descendre la colonne',
                    dupl_col: 'Dupliquer la colonne',
                    del_col: 'Supprimer la colonne'
                }
            },
            ctx_line: {
                title1: 'Menu contextuel',
                title2: '(Ligne)',
                items: {
                    del_line: 'Supprimer la ligne'
                }
            },
            ctx_area: {
                title1: 'Menu contextuel',
                title2: '(Zone)',
                items: {
                    dupl_area: 'Dupliquer la zone',
                    del_area: 'Supprimer la zone'
                }
            },
            ctx_multi: {
                title1: 'Menu contextuel',
                title2: '(Sélection multiple)',
                items: {
                    select_all: 'Sélectionner tous les éléments',
                    create_area_for_select_els: 'Créer une zone pour les éléments sélectionnés',
                    dupl_select_els: 'Dupliquer les éléments sélectionnés',
                    del_select_els: 'Supprimer les éléments sélectionnés'
                }
            }
        },
        t: {
            ctrl_left: {
                mouse_select: 'Sélection à la souris',
                table: 'Table',
                line: 'Ligne',
                area: 'Zone',
                note: 'Remarque (bientôt)',
                comment: 'Commentaire (bientôt)',
                pen: 'Stylo',
                undo: 'Annuler',
                redo: 'Rétablir'
            },
            ctrl_top_left: {
                logo: 'Remarque : ceci est un bac à sable',
                name: 'Informations du diagramme',
                editor: 'Éditeur (bientôt)',
                search: 'Recherche (bientôt)',
                export: 'Options d’export',
                view_mode: 'Mode d’affichage',
                zoom_to_fit: 'Adapter à l’écran'
            },
            ctrl_top_right: {
                feature_req: 'Demande de fonctionnalité',
                sign_in: 'Se connecter',
                quick_share: 'Partage rapide'
            },
            ctrl_bottom_right: {
                full_screen: 'Plein écran',
                minimap: 'Mini-carte',
                zoom_out: 'Zoom arrière',
                zoom_100: 'Zoom à 100 %',
                zoom_in: 'Zoom avant',
                info: 'Informations & ressources'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'Par défaut',
                        blue: 'Bleu',
                        green: 'Vert',
                        red: 'Rouge',
                        purple: 'Violet',
                        violet: 'Violette'
                    },
                    borders: {
                        none: 'Aucune',
                        solid: 'Continu',
                        dashed: 'Tirets',
                        dotted: 'Pointillés'
                    },
                    color: 'Couleur',
                    border: 'Bordure',
                    description: 'Description',
                    description_table_place: 'Description de table',
                    description_column_place: 'Description de colonne',
                    description_line_place: 'Description de ligne',
                    description_note_place: 'Description de remarque',
                    description_area_place: 'Description de zone',
                    description_pen_place: 'Description du tracé',
                    hide_menu: 'Masquer le menu',
                    show_menu: 'Afficher le menu'
                },
                tab_col: {
                    add_col_below: 'Ajouter une colonne en dessous',
                    add_col_above: 'Ajouter une colonne au-dessus',
                    key: 'Key',
                    keys: {
                        none: 'Aucune',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'Aucun',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: 'Descendre la colonne',
                    move_col_up: 'Monter la colonne',
                    more_functions: 'Fonctions supplémentaires'
                },
                line: {
                    change_connects: 'Modifier les connecteurs',
                    connects: {
                        empty: 'Vide',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update',
                    on_delete: 'On Delete'
                },
                area: {
                    filter: 'Filtrer les éléments'
                },
                multi: {
                    filter: 'Filtrer la sélection',
                    create_area: 'Créer une zone'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'Complet',
            keys_only: 'Clés uniquement',
            names_only: 'Noms uniquement'
        },
        dropdown_ctrl_export: {
            export_img: 'Exporter une image',
            export_code: 'Exporter le code SQL'
        },
        dropdown_ctrl_settings: {
            sign_in: 'Se connecter',
            new_project: 'Nouveau projet',
            keyboard_shortcuts: 'Raccourcis clavier',
            languages: 'Langues'
        },
        dropdown_ctrl_info_resources: {
            feedback: 'Commentaires',
            keyboard_shortcuts: 'Raccourcis clavier',
            languages: 'Langues',
            homepage: 'Page d’accueil'
        },
        n: {
            default: 'Chargement…',
            file_ready_to_download: 'Le fichier est prêt à être téléchargé',
            code_copied: 'Le code a été copié',
            link_copied: 'Le lien a été copié',
            please_enter_message: 'Veuillez saisir un message',
            invalid_email: 'L’adresse e-mail n’est pas valide',
            something_wrong_contact: 'Un problème est survenu. Veuillez recharger la page ou nous contacter.',
            something_wrong: 'Un problème est survenu. Veuillez recharger la page.',
            sending: 'Envoi…',
            request_sent: 'La demande a été envoyée. Merci !'
        }
    }
};

export const frMeta = {
    lang_origin: 'Français',
    lang_eng: 'French',
    lang_code: 'fr',
};
